module.exports = __webpack_public_path__ + "img/truck-flatbed.0e454b29.svg";